<template>
	<resources-index :resources="resources" type="course" plural="courses"></resources-index>
</template>

<script>

import ResourcesIndex from '@/views/resources/Index'
import {sync} from "vuex-pathify";
export default {
	name: "CoursesIndex",
	components: {
		ResourcesIndex
	},
	computed: {
		resources: sync('courses/courses'),
	},
}
</script>